import { FormFieldGroup, FormRow, FormSection } from "@portal/components/form";
import {
	FormCurrencyComponent,
	FormDateComponent,
	FormDropdownComponent,
	FormPercentComponent,
	FormYesNoComponent,
} from "@portal/components/form/fieldLayouts";
import { useFormContext } from "react-hook-form";
import { BID_BOND_AMOUNT_TYPE_OPTIONS, BOND_FORM_TYPE_OPTIONS } from "../constants";
import type { AdminImportBondViewFormData } from "../types";

type AmountsAndPremiumSectionProps = {
	isBid: boolean;
	isClosed: boolean;
};

export const AmountsAndPremiumSection = ({ isBid, isClosed }: AmountsAndPremiumSectionProps) => {
	const formMethods = useFormContext<AdminImportBondViewFormData>();

	return (
		<FormSection header="Amounts & Premium">
			<FormFieldGroup condensed>
				<FormRow>
					{isBid ? (
						<>
							<FormCurrencyComponent
								formMethods={formMethods}
								name="bond.data.bidAmount"
								label="Bid Amount"
								inline
							/>
							<FormCurrencyComponent
								formMethods={formMethods}
								name="bond.bondAmount"
								label="Bond Amount"
								inline
							/>
							<FormPercentComponent
								formMethods={formMethods}
								name="bondForm.data.bondAmountPercentOfBid"
								label="Bond Amount %"
								inline
								decimalPlaces={2}
							/>
							<FormDropdownComponent
								formMethods={formMethods}
								name="bondForm.data.bidBondAmountType"
								label="Bond Amount on Bond Form"
								inline
								options={BID_BOND_AMOUNT_TYPE_OPTIONS}
							/>
						</>
					) : (
						<>
							<FormCurrencyComponent
								formMethods={formMethods}
								name="bond.bondAmount"
								label="Bond Amount"
								inline
							/>
							<FormCurrencyComponent
								formMethods={formMethods}
								name="bond.data.contractAmount"
								label="Contract Amount"
								inline
							/>
							{isClosed && (
								<FormCurrencyComponent
									formMethods={formMethods}
									name="bond.data.actualContractAmount"
									label="Contract Amount At Close"
									inline
								/>
							)}
						</>
					)}
				</FormRow>
				<FormRow include={isBid}>
					<FormDateComponent
						formMethods={formMethods}
						name="bond.data.bidDate"
						label="Bid Date"
						inline
					/>
					<FormYesNoComponent
						formMethods={formMethods}
						name="bond.data.tListingRequired"
						label="T-Listing Required"
						inline
					/>
					<FormDropdownComponent
						formMethods={formMethods}
						name="bond.data.finalBondFormType"
						label="Final Bond Form Type"
						inline
						options={BOND_FORM_TYPE_OPTIONS}
						placeholder="Select one"
					/>
					<FormYesNoComponent
						formMethods={formMethods}
						name="bond.data.isFinalBondCompletionBond"
						label="Final Bond = Completion Bond"
						inline
					/>
				</FormRow>
				<FormRow>
					{isBid ? (
						<FormPercentComponent
							formMethods={formMethods}
							name="bond.data.finalBondContingentRate"
							label="Final Bond Rate"
							inline
							decimalPlaces={4}
						/>
					) : (
						<FormPercentComponent
							formMethods={formMethods}
							name="rate"
							label="Rate"
							inline
							decimalPlaces={4}
						/>
					)}
					{isBid ? (
						<FormCurrencyComponent
							formMethods={formMethods}
							name="bond.data.finalBondContingentPremium"
							label="Final Bond Premium"
							inline
						/>
					) : (
						<FormCurrencyComponent
							formMethods={formMethods}
							name="premium"
							label="Premium"
							inline
						/>
					)}
					<FormPercentComponent
						formMethods={formMethods}
						name="agencyCommissionPercentage"
						label={isBid ? "Final Bond Commission %" : "Commission %"}
						inline
						decimalPlaces={2}
					/>
				</FormRow>
			</FormFieldGroup>
		</FormSection>
	);
};
